import { useMutation } from "@apollo/client";

import {
  ExplorerFilterType,
  getQueryVariablesForExplorerFilters,
  testIsAllowedArtifactType,
} from "@apps/explorer/helpers";
import { successNotificationVar } from "@cache/cache";
import Tooltip from "@components/tooltip/tooltip";
import { classNames } from "@helpers/css";

import exportExplorerToCSV from "../graphql/export-to-csv-mutation";
import {
  explorerSelectClassName,
  explorerSelectDisabledClassName,
} from "./filters";

const ExplorerExport: React.FC<{ filters: ExplorerFilterType }> = ({
  filters,
}) => {
  const [triggerExport, { loading }] = useMutation(exportExplorerToCSV);

  const handleClickExport = () => {
    const queryFilters = getQueryVariablesForExplorerFilters(filters);
    triggerExport({ variables: queryFilters }).then(({ data }) => {
      successNotificationVar({
        title: `CSV export will be emailed to ${data.searchCsvExport.user.email}. The link will expire in two hours.`,
      });
    });
  };

  const exportDisabled = !(
    filters.type && testIsAllowedArtifactType(filters.type)
  );
  const buttonDisabled = exportDisabled || loading;

  return (
    <div>
      <Tooltip
        text={
          exportDisabled
            ? "You can only export results containing a single type of Topicflow data"
            : "Export will be sent via email"
        }
      >
        <button
          className={classNames(
            explorerSelectClassName,
            "pr-2",
            buttonDisabled && explorerSelectDisabledClassName
          )}
          disabled={exportDisabled || loading}
          onClick={handleClickExport}
        >
          Export to csv
        </button>
      </Tooltip>
    </div>
  );
};

export default ExplorerExport;
